import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { Constants } from './core/constants';
import { PageGuardService } from './core/guards/page-guard.service';
import { PageGuardAuthService } from './core/guards/page-guard-auth.service';

const routes: Routes = [
  { path: '', redirectTo: '/render-content?pageName=Home', pathMatch: 'full' },
  {
    path: 'login',
    loadChildren: () =>
      import('./pages/login/login.module').then((m) => m.LoginPageModule),
  },
  {
    path: 'documentation-editor',
    loadChildren: () => import('./cdf-documents-editor/document-editor.module').then((m) => m.DocumentEditorModule),
    canActivate: [PageGuardService],
    data: {
      role: Constants.CdfAdminRole
    }
  },
  {
    path: 'admin-content',
    loadChildren: () => import('./admin-content/admin-content.module').then((m) => m.AdminContentModule),
    canActivate: [PageGuardService],
    data: {
      role: Constants.CdfAdminRole
    }
  },
  {
    path: 'render-content',
    loadChildren: () => import('./render-content/render-content.module').then((m) => m.RenderContentModule),
    canActivate: [PageGuardAuthService],
  },
  {
    path: 'document-admin',
    loadChildren: () => import('./admin-document/admin-document.module').then((m) => m.AdminDocumentModule),
    canActivate: [PageGuardService],
    data: {
      role: Constants.CdfAdminRole
    }
  },
  {
    path: 'product-availability',
    loadChildren: () => import('./product/product.module').then((m) => m.ProductModule)
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: PreloadAllModules,
      anchorScrolling: 'enabled'
    }),

  ],
  exports: [RouterModule],
})
export class AppRoutingModule {
}
